import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { SourceApi } from './models/source-api.model';
import { NeptuneApi } from '../genericApi/neptune.api';
import { MultiBaseAbstractApi } from '@api/genericApi/multi-base-abstract.api';

@Injectable()
export class SourceApiService extends MultiBaseAbstractApi<SourceApi, SourceApi> {

    constructor(
        private neptuneApi: NeptuneApi
    ) {
        super();
    }

    getList(): Observable<SourceApi[]> {
        const slug: string = '/source/all';

        return this.neptuneApi.api<SourceApi[]>(
            slug,
            null,
            HttpVerbsEnum.GET
        );
    }


    create(source: SourceApi): Observable<number> {
        const slug: string = '/source';

        return this.neptuneApi.api<number>(
            slug,
            source,
            HttpVerbsEnum.POST
        );
    }


    deleteByIds(ids: number[]): Observable<null> {
        const slug: string = '/source';

        return this.neptuneApi.api<null>(
            slug,
            ids,
            HttpVerbsEnum.DELETE
        );
    }


    update(source: SourceApi): Observable<null> {
        const slug: string = `/source/${source.id}`;

        return this.neptuneApi.api<null>(
            slug,
            source,
            HttpVerbsEnum.PUT
        );
    }

    createBatch(sources: SourceApi[]): Observable<number[]> {
        const slug: string = '/source/batch';

        return this.neptuneApi.api<number[]>(
            slug,
            sources,
            HttpVerbsEnum.POST
        );
    }
}
